// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76250c27","455":"2846fac8","488":"024ee3b8","977":"bb456f2e"}[chunkId] + ".chunk.js";
};